"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newBrunswickCities = void 0;
exports.newBrunswickCities = [
    {
        label: "Acadieville",
        value: 625,
    },
    {
        label: "Alma, NB",
        value: 610,
    },
    {
        label: "Andover",
        value: 611,
    },
    {
        label: "Aroostook",
        value: 612,
    },
    {
        label: "Arthurette",
        value: 613,
    },
    {
        label: "Atholville",
        value: 614,
    },
    {
        label: "Back Bay",
        value: 615,
    },
    {
        label: "Baie Sainte-Anne",
        value: 618,
    },
    {
        label: "Bains Corner",
        value: 623,
    },
    {
        label: "Baker Brook",
        value: 620,
    },
    {
        label: "Barkers Point",
        value: 622,
    },
    {
        label: "Bath, NB",
        value: 624,
    },
    {
        label: "Bathurst",
        value: 626,
    },
    {
        label: "Beaconsfield, NB",
        value: 627,
    },
    {
        label: "Bedell",
        value: 629,
    },
    {
        label: "Belledune",
        value: 628,
    },
    {
        label: "Beresford",
        value: 630,
    },
    {
        label: "Bertrand",
        value: 632,
    },
    {
        label: "Berts Cove",
        value: 953,
    },
    {
        label: "Blacks Harbour",
        value: 633,
    },
    {
        label: "Blackville",
        value: 634,
    },
    {
        label: "Bloomfield, NB",
        value: 635,
    },
    {
        label: "Bouctouche",
        value: 640,
    },
    {
        label: "Bridgedale",
        value: 636,
    },
    {
        label: "Bristol",
        value: 638,
    },
    {
        label: "Browns Flat",
        value: 639,
    },
    {
        label: "Bulls Creek",
        value: 667,
    },
    {
        label: "Cambridge Narrows",
        value: 650,
    },
    {
        label: "Campbellton",
        value: 652,
    },
    {
        label: "Campobello",
        value: 653,
    },
    {
        label: "Canterbury",
        value: 654,
    },
    {
        label: "Cap Pele",
        value: 656,
    },
    {
        label: "Cape Tourmentine",
        value: 657,
    },
    {
        label: "Caraquet",
        value: 658,
    },
    {
        label: "Carlingford",
        value: 712,
    },
    {
        label: "Centreville, NB",
        value: 660,
    },
    {
        label: "Charlo",
        value: 662,
    },
    {
        label: "Chartersville",
        value: 664,
    },
    {
        label: "Chatham, NB",
        value: 666,
    },
    {
        label: "Chipman, NB",
        value: 668,
    },
    {
        label: "Clair",
        value: 670,
    },
    {
        label: "Clairville",
        value: 669,
    },
    {
        label: "Cocagne",
        value: 673,
    },
    {
        label: "Codys",
        value: 671,
    },
    {
        label: "Coles Island",
        value: 954,
    },
    {
        label: "College Bridge",
        value: 672,
    },
    {
        label: "Colpitts Settl.",
        value: 621,
    },
    {
        label: "Connors",
        value: 674,
    },
    {
        label: "Cummings Cove",
        value: 687,
    },
    {
        label: "Dalhousie, NB",
        value: 680,
    },
    {
        label: "Deer Island Point",
        value: 681,
    },
    {
        label: "Dieppe",
        value: 774,
    },
    {
        label: "Dipper Harbour",
        value: 9102,
    },
    {
        label: "Doaktown",
        value: 682,
    },
    {
        label: "Dorchester, NB",
        value: 684,
    },
    {
        label: "Douglastown",
        value: 686,
    },
    {
        label: "Drummond",
        value: 688,
    },
    {
        label: "East Riverside-Kingshurst",
        value: 690,
    },
    {
        label: "East Shediac",
        value: 692,
    },
    {
        label: "Edmundston",
        value: 694,
    },
    {
        label: "Eel River Crossin",
        value: 700,
    },
    {
        label: "Eng. Settlement",
        value: 683,
    },
    {
        label: "Fairhaven",
        value: 701,
    },
    {
        label: "Fairvale",
        value: 852,
    },
    {
        label: "Florenceville",
        value: 702,
    },
    {
        label: "Forest City",
        value: 703,
    },
    {
        label: "Fosterville",
        value: 705,
    },
    {
        label: "Four Falls",
        value: 709,
    },
    {
        label: "Fredericton",
        value: 704,
    },
    {
        label: "Fredericton Junct",
        value: 710,
    },
    {
        label: "Gagetown",
        value: 716,
    },
    {
        label: "Gaspereau Forks",
        value: 713,
    },
    {
        label: "Gillespie",
        value: 717,
    },
    {
        label: "Gondola Point",
        value: 718,
    },
    {
        label: "Grand Falls, NB",
        value: 722,
    },
    {
        label: "Grand Harbour",
        value: 724,
    },
    {
        label: "Grand Manan",
        value: 725,
    },
    {
        label: "Grande-Anse",
        value: 720,
    },
    {
        label: "Green Point",
        value: 727,
    },
    {
        label: "Gunningsville",
        value: 726,
    },
    {
        label: "Hampton, NB",
        value: 728,
    },
    {
        label: "Hanwell",
        value: 631,
    },
    {
        label: "Harcourt",
        value: 729,
    },
    {
        label: "Hartland",
        value: 730,
    },
    {
        label: "Harvey",
        value: 732,
    },
    {
        label: "Hillsborough",
        value: 734,
    },
    {
        label: "Hopewell Cape",
        value: 736,
    },
    {
        label: "Jacksontown",
        value: 637,
    },
    {
        label: "Jacquet River",
        value: 740,
    },
    {
        label: "Juniper",
        value: 743,
    },
    {
        label: "Kedgewick",
        value: 746,
    },
    {
        label: "Keswick Ridge",
        value: 685,
    },
    {
        label: "Kouchibouguac",
        value: 955,
    },
    {
        label: "Lac Baker",
        value: 750,
    },
    {
        label: "Lakeville",
        value: 751,
    },
    {
        label: "Lameque",
        value: 752,
    },
    {
        label: "Lancaster, NB",
        value: 854,
    },
    {
        label: "Lansdowne, NB",
        value: 855,
    },
    {
        label: "Lewisville",
        value: 776,
    },
    {
        label: "Lincoln Heights",
        value: 753,
    },
    {
        label: "Little River",
        value: 689,
    },
    {
        label: "Loch Lomond",
        value: 755,
    },
    {
        label: "Loggieville",
        value: 754,
    },
    {
        label: "Lower Brighton",
        value: 642,
    },
    {
        label: "Lower Caraquet",
        value: 756,
    },
    {
        label: "Ludlow",
        value: 757,
    },
    {
        label: "Maisonnette",
        value: 759,
    },
    {
        label: "Mars Hill Road",
        value: 761,
    },
    {
        label: "Marysville, NB",
        value: 706,
    },
    {
        label: "Maugerville",
        value: 714,
    },
    {
        label: "McAdam",
        value: 760,
    },
    {
        label: "Mckenna",
        value: 651,
    },
    {
        label: "Meductic",
        value: 762,
    },
    {
        label: "Memramcook",
        value: 715,
    },
    {
        label: "Millerton",
        value: 763,
    },
    {
        label: "Milltown, NB",
        value: 764,
    },
    {
        label: "Millville",
        value: 766,
    },
    {
        label: "Minto, NB",
        value: 768,
    },
    {
        label: "Miramichi",
        value: 770,
    },
    {
        label: "Miscou Centre",
        value: 771,
    },
    {
        label: "Mohannes",
        value: 691,
    },
    {
        label: "Moncton",
        value: 772,
    },
    {
        label: "Nackawic",
        value: 780,
    },
    {
        label: "Napan",
        value: 719,
    },
    {
        label: "Nashwaaksis",
        value: 708,
    },
    {
        label: "Neguac",
        value: 782,
    },
    {
        label: "Nelson, NB",
        value: 784,
    },
    {
        label: "New Denmark",
        value: 787,
    },
    {
        label: "New Maryland",
        value: 619,
    },
    {
        label: "Newcastle, NB",
        value: 786,
    },
    {
        label: "Nigadoo",
        value: 788,
    },
    {
        label: "North Head",
        value: 790,
    },
    {
        label: "Northampton",
        value: 655,
    },
    {
        label: "Norton",
        value: 792,
    },
    {
        label: "Notre Dame, NB",
        value: 794,
    },
    {
        label: "Oak Bay, NB",
        value: 659,
    },
    {
        label: "Oakland, NB",
        value: 693,
    },
    {
        label: "Oromocto",
        value: 800,
    },
    {
        label: "Other",
        value: 999,
    },
    {
        label: "Pamdenec",
        value: 806,
    },
    {
        label: "Paquetville",
        value: 808,
    },
    {
        label: "Peel",
        value: 675,
    },
    {
        label: "Pennfield",
        value: 956,
    },
    {
        label: "Perth, NB",
        value: 809,
    },
    {
        label: "Perth-Andover",
        value: 810,
    },
    {
        label: "Petit Rocher",
        value: 812,
    },
    {
        label: "Petitcodiac",
        value: 814,
    },
    {
        label: "Plaster Rock",
        value: 816,
    },
    {
        label: "Pleasant Villa",
        value: 661,
    },
    {
        label: "Pointe-du-ChÃªne",
        value: 817,
    },
    {
        label: "Pointe-Verte",
        value: 818,
    },
    {
        label: "Port Elgin, NB",
        value: 820,
    },
    {
        label: "Prince William",
        value: 823,
    },
    {
        label: "Quispamsis",
        value: 826,
    },
    {
        label: "Red Bank",
        value: 828,
    },
    {
        label: "Renforth",
        value: 830,
    },
    {
        label: "Renous",
        value: 829,
    },
    {
        label: "Rexton",
        value: 832,
    },
    {
        label: "Richibucto",
        value: 834,
    },
    {
        label: "River de Chute",
        value: 835,
    },
    {
        label: "Riverbank",
        value: 616,
    },
    {
        label: "Riverside-Albert",
        value: 836,
    },
    {
        label: "Riverview",
        value: 837,
    },
    {
        label: "Riverview Heights",
        value: 778,
    },
    {
        label: "Riviere-Verte",
        value: 838,
    },
    {
        label: "Robichaud",
        value: 839,
    },
    {
        label: "Rogersville",
        value: 840,
    },
    {
        label: "Rothesay",
        value: 842,
    },
    {
        label: "Sackville, NB",
        value: 848,
    },
    {
        label: "Saint Andrews",
        value: 880,
    },
    {
        label: "Saint Hilaire",
        value: 890,
    },
    {
        label: "Saint John, NB",
        value: 850,
    },
    {
        label: "Saint-AndrÃ©",
        value: 878,
    },
    {
        label: "Saint-Anselme",
        value: 884,
    },
    {
        label: "Saint-Antoine",
        value: 858,
    },
    {
        label: "Saint-Basile",
        value: 696,
    },
    {
        label: "Saint-Charles",
        value: 721,
    },
    {
        label: "Sainte-Anne-de-Kent",
        value: 957,
    },
    {
        label: "Sainte-Anne-de-Madawaska",
        value: 882,
    },
    {
        label: "Saint-Edouard-de-Kent",
        value: 695,
    },
    {
        label: "Sainte-Marie-de-Kent",
        value: 899,
    },
    {
        label: "Saint-FranÃ§ois-de-Madawaska",
        value: 886,
    },
    {
        label: "Saint-Jacques",
        value: 892,
    },
    {
        label: "Saint-Joseph, NB",
        value: 894,
    },
    {
        label: "Saint-Leonard, NB",
        value: 896,
    },
    {
        label: "Saint-Louis-de-Kent",
        value: 898,
    },
    {
        label: "Saint-Quentin",
        value: 902,
    },
    {
        label: "Salisbury",
        value: 860,
    },
    {
        label: "Scoudouc",
        value: 641,
    },
    {
        label: "Sea Cove, NB",
        value: 862,
    },
    {
        label: "Shediac",
        value: 866,
    },
    {
        label: "Shippegan",
        value: 868,
    },
    {
        label: "Silverwood",
        value: 870,
    },
    {
        label: "St George, NB",
        value: 888,
    },
    {
        label: "St Martins",
        value: 900,
    },
    {
        label: "St Stephen",
        value: 904,
    },
    {
        label: "Stanley",
        value: 910,
    },
    {
        label: "Stickney",
        value: 911,
    },
    {
        label: "Summerfield",
        value: 676,
    },
    {
        label: "Surrey, NB",
        value: 916,
    },
    {
        label: "Sussex",
        value: 918,
    },
    {
        label: "Sussex Corner",
        value: 831,
    },
    {
        label: "Taymouth",
        value: 920,
    },
    {
        label: "Tide Head",
        value: 924,
    },
    {
        label: "Tracadie",
        value: 928,
    },
    {
        label: "Tracadie-Sheila",
        value: 697,
    },
    {
        label: "Tracy, NB",
        value: 930,
    },
    {
        label: "Upper Coverdale",
        value: 678,
    },
    {
        label: "Upper Kent",
        value: 958,
    },
    {
        label: "Upper Woodstock",
        value: 677,
    },
    {
        label: "Wakefield, NB",
        value: 663,
    },
    {
        label: "Waterville",
        value: 698,
    },
    {
        label: "Welshpool",
        value: 946,
    },
    {
        label: "Westfield",
        value: 950,
    },
    {
        label: "Whitehead",
        value: 707,
    },
    {
        label: "Wicklow",
        value: 711,
    },
    {
        label: "Wilson's Beach",
        value: 951,
    },
    {
        label: "Woodside",
        value: 665,
    },
    {
        label: "Woodstock, NB",
        value: 952,
    },
    {
        label: "Youngs Cove",
        value: 679,
    },
    {
        label: "Zealand",
        value: 970,
    },
];
